import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';

// views
import Home from './views/Home/Home.vue';
import Admin from './views/Admin/Admin.vue';
import Stats from './views/Stats/Stats.vue';
import Clients from './views/Clients/Clients.vue';
import Client from './views/Client/Client.vue';
import OrderData from './views/OrderData/OrderData.vue';
import OrderEdit from './views/OrderEdit/OrderEdit.vue';
import Orders from './views/Orders/Orders.vue';
import Settings from './views/Settings/Settings.vue';
import Account from './views/Account/Account.vue';
import Payments from './views/Payments/Payments.vue';
import Coupe from './views/Coupe/Coupe.vue';
import PriceAndMargin from './views/PriceAndMargin/PriceAndMargin.vue';
import Branding from './views/Branding/Branding.vue';
import Notifications from './views/Notifications/Notifications.vue';
import Install from './views/Install/Install.vue';
import InstallDocs from './views/InstallDocs/InstallDocs.vue';

import config from './config';

// components
import ChildView from './components/ChildView/ChildView.vue';
import ContentHeader from './components/ContentHeader/ContentHeader.vue';

import Login from './components/auth/Login/Login.vue';
import Register from './components/auth/Register/Register.vue';
import Restore from './components/auth/Restore/Restore.vue';
import Reset from './components/auth/Reset/Reset.vue';

// import AdminLayout from './../components/layout/layout';
// import Dashboard from './../components/dashboard';

Vue.use(Router);

const router = new Router({
  base: config.prefix,
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/login',
      name: 'login',
      components: {
        auth: Login
      },
      meta: {
        title: 'Вход',
        withoutAuth: true
      }
    },
    {
      path: '/register',
      name: 'register',
      components: {
        auth: Register
      },
      meta: {
        title: 'Регистрация',
        withoutAuth: true
      }
    },
    {
      path: '/restore',
      name: 'restore',
      components: {
        auth: Restore
      },
      meta: {
        title: 'Восстановление пароля',
        withoutAuth: true
      }
    },
    {
      path: '/reset/:token',
      name: 'reset',
      props: { auth: true },
      components: {
        auth: Reset
      },
      meta: {
        title: 'Сброс пароля',
        withoutAuth: true
      }
    },
    {
      path: '/',
      name: 'home',
      components: {
        default: Home,
        header: ContentHeader
      },
      meta: {
        title: 'Главная',
        tutorial: true,
        tutorialStepId: 0,
        disableForAdmin: false
      }
    },
    {
      path: '/admin',
      name: 'admin',
      components: {
        default: Admin,
        header: ContentHeader
      },
      meta: {
        title: 'Управление',
        admin: true
      }
    },
    {
      path: '/stats',
      name: 'stats',
      components: {
        default: Stats,
        header: ContentHeader
      },
      meta: {
        title: 'Статистика'
      }
    },
    {
      path: '/orders',
      components: {
        default: ChildView,
        header: ContentHeader
      },
      children: [
        {
          name: 'orders',
          path: '/orders/:status?',
          components: { default: Orders },
          props: { default: true, header: false },
          meta: {
            title: 'Мои заказы',
            tutorial: true,
            tutorialStepId: 1
          }
        },
        {
          name: 'orders.order',
          path: 'order/:orderId',
          components: { default: OrderData },
          props: { default: true, header: false },
          meta: { title: 'Данные о заказе' }
        },
        {
          name: 'orders.order.edit',
          path: 'order/:orderId/edit',
          components: { default: OrderEdit },
          props: { default: true, header: false },
          meta: { title: 'Редактировать шкаф' }
        }
      ]
    },

    {
      path: '/clients',
      components: {
        default: ChildView,
        header: ContentHeader
      },

      children: [
        {
          path: '',
          name: 'clients',
          components: { default: Clients },
          meta: {
            title: 'Мои клиенты',
            tutorial: true,
            tutorialStepId: 2
          },
          props: { default: true, header: false }
        },
        {
          path: '/clients/:clientId',
          name: 'clients.client',
          components: { default: Client },
          props: { default: true, header: false },
          meta: { title: 'Данные о клиенте' }
        }
      ]
    },

    {
      path: '/settings/',
      components: {
        default: ChildView,
        header: ContentHeader
      },

      children: [
        {
          path: '',
          name: 'settings',
          components: {
            default: Settings,
            header: ContentHeader
          },
          meta: {
            title: 'Мои настройки'
          }
        },
        {
          path: 'account',
          name: 'account',
          components: {
            default: Account
          },
          meta: {
            title: 'Мои настройки: Данные аккаунта',
            tutorial: true,
            tutorialStepId: 3
          }
        },
        {
          path: 'payments',
          name: 'payments',
          components: {
            default: Payments
          },
          meta: {
            title: 'Мои настройки: Платежи и баланс',
            disableForAdmin: true,
            tutorial: true,
            tutorialStepId: 4
          }
        }
      ]
    },

    {
      path: '/constructors/:constructorId',
      components: {
        default: ChildView,
        header: ContentHeader
      },
      children: [
        {
          name: 'constructors.constructor',
          path: '',
          component: Coupe,
          meta: {
            title: 'Мои конструкторы',
            disableOnFreePlan: true,
            tutorial: true,
            tutorialStepId: 5
          }
        },
        {
          name: 'constructors.constructor.prices',
          path: 'prices',
          component: PriceAndMargin,
          meta: {
            title: 'Материалы, элементы наполнения и фурнитура',
            disableOnFreePlan: true,
            tutorial: true,
            tutorialStepId: 6
          }
        },
        {
          name: 'constructors.constructor.branding',
          path: 'branding',
          component: Branding,
          meta: {
            title: 'Брендирование',
            disableOnFreePlan: true,
            disableForAdmin: true,
            tutorial: true,
            tutorialStepId: 7
          }
        },
        {
          name: 'constructors.constructor.notifications',
          path: 'notifications',
          component: Notifications,
          meta: {
            title: 'Уведомления и e-mail',
            disableOnFreePlan: true,
            disableForAdmin: true,
            tutorial: true,
            tutorialStepId: 8
          }
        },
        {
          name: 'constructors.constructor.install',
          path: 'install',
          component: Install,
          meta: {
            title: 'Установить на сайт',
            disableOnFreePlan: true,
            disableForAdmin: true,
            tutorial: true,
            tutorialStepId: 9
          }
        },
        {
          name: 'constructors.constructor.install.docs',
          path: 'docs',
          component: InstallDocs,
          meta: {
            title: 'Как установить',
            disableOnFreePlan: false,
            disableForAdmin: true
          }
        }
      ]
    }
  ],

  scrollBehavior: (to, _from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    }

    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => !record.meta.withoutAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.meta.admin && !store.getters.isAdmin) {
        next('/');
      } else {
        next();
      }
      return;
    }
    next('/login');
  } else if (store.getters.isLoggedIn) {
    next('/');
  } else {
    next();
  }
});

export default router;
